import React, { useState } from 'react'

import {
  POPOVER_POSITION,
  Popover,
  PopoverPosition,
} from 'modules/core/components/DateNavigator/_Popover'
import { FixedDuration } from 'modules/core/components/DateNavigator/constants'
import { Cycle } from 'modules/core/components/DateNavigator/cycleUtils'
import { moveRange } from 'modules/core/components/DateNavigator/dateUtils'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'

import { DateRangeSelectorBody } from './_DateRangeSelectorBody'
import { NavigatorChip } from './_NavigatorChip'

type Props = {
  regularPeriods?: FixedDuration[]

  cycle?: Cycle
  startDate: Date
  endDate: Date
  longMonth?: boolean
  withRelativeDates?: boolean
  onDateRangeChange: (startDate: Date, endDate: Date) => void
}

export const DateRangeSelector = ({
  regularPeriods,
  cycle,
  startDate,
  endDate,
  longMonth,
  withRelativeDates,
  onDateRangeChange,
}: Props) => {
  const [popoverOpen, setPopoverOpen] = useState(false)

  const handleOpenPopover = useUnsafeCallback(() => {
    setPopoverOpen(true)
  }, [])

  const handleClosePopover = useUnsafeCallback(() => {
    setPopoverOpen(false)
  }, [])

  const handleLeftStepperClick = useUnsafeCallback(() => {
    const newRange = moveRange(startDate, endDate, 'backward')

    onDateRangeChange(newRange[0], newRange[1])
  }, [startDate, endDate, onDateRangeChange])

  const handleRightStepperClick = useUnsafeCallback(() => {
    const newRange = moveRange(startDate, endDate, 'forward')

    onDateRangeChange(newRange[0], newRange[1])
  }, [startDate, endDate, onDateRangeChange])

  const [popoverPosition, setPopoverPosition] = React.useState<PopoverPosition>(POPOVER_POSITION)

  return (
    <Popover
      open={popoverOpen}
      onClose={handleClosePopover}
      attachment={popoverPosition.attachment}
      targetAttachment={popoverPosition.targetAttachment}
      trigger={
        <NavigatorChip
          startDate={startDate}
          endDate={endDate}
          longMonth={longMonth}
          withRelativeDates={withRelativeDates}
          onDateClick={handleOpenPopover}
          onLeftStepperClick={handleLeftStepperClick}
          onRightStepperClick={handleRightStepperClick}
        />
      }
    >
      <DateRangeSelectorBody
        regularPeriods={regularPeriods}
        cycle={cycle}
        startDate={startDate}
        endDate={endDate}
        onDateRangeChange={onDateRangeChange}
        setPopoverPosition={setPopoverPosition}
      />
    </Popover>
  )
}
